'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.magic = void 0;
var tslib_1 = require("tslib");
var transport_1 = require("./transport");
var methods = tslib_1.__importStar(require("./methods"));
var events_1 = require("./events");
var session_1 = require("./session/session");
var in_memory_api_cache_service_1 = require("./cache/in-memory-api-cache.service");
var Magic = /** @class */ (function () {
    function Magic(cacheService) {
        this.events = events_1.events;
        this.methods = methods;
        this.session = session_1.session;
        this.transport = transport_1.transport;
        this.cacheService = cacheService;
    }
    /**
     * Sets up the Magic SDK by initialising all connections and services
     * @param opts SDK configuration options
     * @returns Resolves when the connection is stablished and ready to use
     */
    Magic.prototype.setup = function (opts) {
        return transport_1.transport.setup(opts);
    };
    /**
     * Connects to the Magic SDK WebSocket server
     * @returns Resolves when the connection is stablished and ready to use
     */
    Magic.prototype.wsConnect = function () {
        return transport_1.transport.wsConnect();
    };
    /**
     * Performs all requried cleanup actions when destroying the SDK
     */
    Magic.prototype.destroy = function () {
        return transport_1.transport.destroy();
    };
    /**
     * If the `recordLastActivity` option is enabled,
     * it will return the timestamp of when the lastest
     * request was started
     * @returns Latest request start timestamp
     */
    Magic.prototype.getLastRequestTimestamp = function () {
        return transport_1.transport.getLastTimestamp();
    };
    Magic.prototype.connectWsDriver = function () {
        return transport_1.transport.connectWsDriver();
    };
    /**
     * Invoke an API method trying to fetch the response from a cache.
     * If the response is available and not expired, it is returned.
     * If the response is not available, the API call gets performed and the
     * response gets cached with the specified ttl
     *
     * @example
     * const lastPlayedPromise: ReturnType<typeof magic.methods.games.getLastPlayedGames> = magic.invokeCached(
     *      60,
     *       magic.methods.games,
     *      'getLastPlayedGames',
     *   )(maxGames * 2);
     *  const lastPlayed = await lastPlayedPromise;
     *
     * @param ttl time to live in seconds
     * @param methodClass the class object containing the method to be invoked
     * @param method the method to invoke
     */
    Magic.prototype.invokeCached = function (ttl, methodClass, method) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var cacheKey, cachedResponse, response;
                var _a;
                return tslib_1.__generator(this, function (_b) {
                    cacheKey = this.generateCacheKey(methodClass.constructor.name, method, args);
                    cachedResponse = this.cacheService.get(cacheKey);
                    if (cachedResponse !== null) {
                        return [2 /*return*/, cachedResponse];
                    }
                    response = (_a = methodClass[method]).call.apply(_a, tslib_1.__spreadArray([methodClass], tslib_1.__read(args)));
                    this.cacheService.set(cacheKey, response, ttl);
                    return [2 /*return*/, response];
                });
            });
        };
    };
    /**
     * Delete a cached API response from the cache.
     *
     * @example
     * magic.deleteCached(
     *       magic.methods.games,
     *      'getLastPlayedGames',
     *   )(maxGames * 2);
     *
     * @param methodClass the class object containing the method to be invoked
     * @param method the method to invoke
     */
    Magic.prototype.deleteCached = function (methodClass, method) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var cacheKey, cachedResponse;
                return tslib_1.__generator(this, function (_a) {
                    cacheKey = this.generateCacheKey(methodClass.constructor.name, method, args);
                    cachedResponse = this.cacheService.get(cacheKey);
                    if (cachedResponse !== null) {
                        this.cacheService.deleteCached(cacheKey);
                    }
                    return [2 /*return*/];
                });
            });
        };
    };
    Magic.prototype.generateCacheKey = function (className, methodName, params) {
        var keyObject = {
            className: className,
            methodName: methodName,
            params: params,
        };
        return JSON.stringify(keyObject);
    };
    return Magic;
}());
exports.magic = new Magic(in_memory_api_cache_service_1.InMemoryApiCacheService.getInstance());
